
    var doc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AuctionType"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AuctionType"}},"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"name"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"bidsVisible"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"mustOverbid"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"isExternal"},"arguments":[],"directives":[]}]}}],"loc":{"start":0,"end":93}};
    doc.loc.source = {"body":"fragment AuctionType on AuctionType {\n  id\n  name\n  bidsVisible\n  mustOverbid\n  isExternal\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

      module.exports = doc;
    
